<template>
  <client-only>
    <PageHeader
      title="Fiókom"
      hero-class="bg-profile hidden lg:flex"
      :breadcrumb="[ {name:'Fiókom', url:'/fiokom'}, id ? 'Esemény szerkesztése' : 'Új esemény felvitele' ]"
    >
      <ReOverlayLoader :loading="isSaving">
        <section
          class=" bg-white pb-14 w-full"
        >
          <ProfileHeader />
          <div class="py-4 lg:py-14 px-4 lg:px-16"> 
            <div
              v-if="!isAdmin()"
              class="w-full alert"
            >
              Mielőtt felviszel egy eseményt, ellenőrizd, hogy nincs-e már bent a Folknaptárban! Ha benne van, de jobb adatokat tudsz vagy te vagy az esemény szervezője, írj nekünk és megoldjuk a cserét!<br><br>
              Az esemény megnevezése legyen a lehető legtömörebb! Légy precíz, írj minden adatot a megfelelő mezőbe!<br><br>
              A Folknaptárba felvitt eseményeket rendszeresen átnézzük, a témánkba nem illő tartalmakat töröljük, a hibákat javítjuk.<br><br>
              Ha kérdésed, problémád van, írj nekünk az <a
                class="link link-red"
                href="mailto:info@folkradio.hu"
              >info@folkradio.hu</a> címre!
            </div>
            <SubTitle
              title="Alapadatok"
              class="mt-3"
            />
            <div class="w-full flex flex-col lg:flex-row flex-wrap  mt-8">
              <div class="w-full lg:w-1/2 lg:inline-flex flex flex-col order-1 lg:pr-[6px] lg:order-none">
                <ReInput
                  id="title"
                  v-model="form.title"
                  :validation-errors="validationErrors.title"
                  placeholder="Esemény elnevezése*"
                  class="w-full"
                  type="text"
                  icon="/img/a_icon.svg"
                />
                <ReSelect
                  v-model="form.types"
                  :items="types"
                  :validation-errors="validationErrors.types"
                  has-filter
                  placeholder="Kategória*"
                  multiple
                />
                <span class="text-center text-semigray">Jelöld meg a dátumo(ka)t az alábbi naptárban!</span>
                <DatePicker
                  v-model="selectedDays"
                  class="mt-3"
                />
                <ReDraggable
                  v-model="selectedDays"
                  placeholder="Kiválasztott dátumok"
                  icon="/img/calendar_icon.svg"
                  :validation-errors="validationErrors.time_details"
                />
                <!-- 
              :validation-errors="validationErrors.time_details" -->
                <span
                  v-if="selectedDays.length > 1 && groupeable"
                  class="w-full -mt-8 mb-4  z-20"
                >
                  <ReCheckbox
                    v-model="form.group_event"
                    class="h-8"
                  >
                    Összefüggő esemény
                  </ReCheckbox>
                </span>
                <div class="w-full flex flex-row gap-3">
                  <ReClock
                    v-model="form.fromTime"
                    placeholder="Kezdés"
                    icon="/img/clock2_icon.svg"
                    class="w-1/2"
                  />
                  <!-- <ReSelect
                    v-model="form.fromTime"
                    :items="timesOfDay"
                    placeholder="Kezdés"
                    icon="/img/clock2_icon.svg"
                    class="w-1/2"
                  /> -->
                  <ReClock
                    v-model="form.toTime"
                    placeholder="Vége"
                    icon="/img/clock2_icon.svg"
                    class="w-1/2"
                  />
                  <!-- <ReSelect
                    v-model="form.toTime"
                    :items="timesOfDay"
                    placeholder="Vége"
                    icon="/img/clock2_icon.svg"
                    class="w-1/2"
                  /> -->
                </div>
              </div>
              <div class="w-full lg:w-1/2 lg:inline-flex flex flex-col order-4 lg:pl-2 lg:order-none">
                <ReInput
                  id="place_name"
                  v-model="
                    form.location_details[form.main_map_index].place_name
                  "
                  class="w-full"
                  placeholder="Helyszín neve"
                  icon="/img/building_icon.svg"
                  type="text"
                />
                <div class="w-full">
                  <client-only>
                    <button v-if="!showMap" @click="showMap = true" class="btn btn-yellow mb-4">Térkép megjelenítése</button>
                    <div v-if="showMap">
                      <div class="search">
                        <GmapAutocomplete
                          @place_changed="setPlace($event, -1)" 
                        />
                      </div>
                      <GmapMap
                        :center="
                          form.location_details[form.main_map_index].marker.position
                            ? form.location_details[form.main_map_index].marker
                              .position
                            : { lat: 47.14932639723332, lng: 20.34087591232901 }
                        "
                        :zoom="
                          form.location_details[form.main_map_index].zoom
                            ? form.location_details[form.main_map_index].zoom
                            : 6
                        "
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: true,
                          disableDefaultUi: false
                        }"
                        class="h-[210px] lg:h-[486px] w-full mb-4"
                        map-type-id="terrain"
                        @click="clickOnMap($event, -1)"
                      >
                        <GmapMarker
                          v-if="
                            form.location_details[form.main_map_index].marker &&
                              form.location_details[form.main_map_index].marker
                                .position
                          "
                          :position="
                            form.location_details[form.main_map_index].marker.position
                          "
                          label="★"
                        />
                      </GmapMap>
                    </div>
                  </client-only>
                </div>
            
                <div class="w-full flex flex-row gap-3 flex-wrap lg:flex-nowrap">
                  <ReInput
                    id="country"
                    v-model="form.location_details[form.main_map_index].country"
                    :validation-errors="
                      validationErrors['location_details.0.country']
                    "
                    class="w-full lg:w-1/2"
                    placeholder="Ország *"
                    icon="/img/globe_icon.svg"
                    type="text"
                    @blur="refreshMap(-1)"
                  />
                  <ReInput
                    id="city"
                    v-model="form.location_details[form.main_map_index].city"
                    placeholder="Település"
                    class="w-full lg:w-1/2"
                    icon="/img/marker_icon.svg"
                    type="text"
                    :validation-errors="
                      validationErrors['location_details.0.city']
                    "
                    @blur="refreshMap(-1)"
                  />
                </div>
            
                <div class="w-full flex flex-row gap-3 flex-wrap lg:flex-nowrap">
                  <ReInput
                    id="street"
                    v-model="form.location_details[form.main_map_index].address"
                    placeholder="Utca"
                    class="w-full lg:w-1/2"
                    type="text"
                    icon="/img/road_icon.svg"
                  />
                  <div
                    class="w-full lg:w-1/2 flex flex-row gap-3"
                  >
                    <ReInput
                      id="street_number"
                      v-model="
                        form.location_details[form.main_map_index].street_number
                      "
                      class="w-1/2"
                      placeholder="Házszám"
                      icon="/img/pin_icon.svg"
                      type="text"
                    />
                    <ReInput
                      id="zip"
                      v-model="form.location_details[form.main_map_index].zip"
                      class="w-1/2"
                      placeholder="Irsz."
                      icon="/img/flag_icon.svg"
                      type="text"
                    />
                  </div>
                </div>
              </div>
              <div
                v-if="clone"
                class="w-full order-2 lg:order-none flex"
              >
                <div
                  class="alert"
                >
                  Klónozott esemény. Változtasd meg a dátumo(ka)t!
                </div>
              </div>
              <div class="w-full order-3 lg:order-none">
                <ReTextarea
                  v-model="form.description"
                  :placeholder="'Leírás'"
                  class="w-full"
                  :rows="15"
                  icon="/img/note_icon.svg"
                  :validation-errors="validationErrors['description']"
                />
              </div>
            </div>
        
            <SubTitle
              title="Szervező"
              class="mt-3"
            />
            <div class="w-full flex flex-col lg:flex-row gap-3 mt-8">
              <div class="w-full lg:w-1/2 flex flex-row lg:flex-col flex-wrap lg:flex-nowrap">
                <ReInput
                  id="org_name"
                  v-model="form.org_name"
                  placeholder="Szervezet vagy személy neve"
                  class="w-full"
                  type="text"
                  icon="/img/building_icon.svg"
                />
                <ReInput
                  id="org_contact"
                  v-model="form.org_contact"
                  placeholder="Kapcsolattartó"
                  icon="/img/profile2_icon.svg"
                  class="w-full"
                  type="text"
                />
              </div>
              <div class="w-full lg:w-1/2 flex flex-row lg:flex-col flex-wrap lg:flex-nowrap">
                <ReInput
                  id="org_email"
                  v-model="form.org_email"
                  placeholder="E-mail cím"
                  class="w-full"
                  type="email"
                  icon="/img/mail2_icon.svg"
                  :validation-errors="validationErrors['org_email']"
                />
                <ReInput
                  id="org_phone"
                  v-model="form.org_phone"
                  placeholder="Telefonszám"
                  class="w-full"
                  icon="/img/phone_icon.svg"
                  type="text"
                />
              </div>
            </div>

        
            <SubTitle
              title="Kapcsolódó oldalak"
              class="mt-3"
            >
              <template>
                <button
                  type="button"
                  class="my-4 mr-3 inline action-icon icon-red-outline"
                  @click="form.media.links.push({ name: '', url: '' })"
                >
                  <i class="fas fa-plus" />
                </button>
              </template>
            </SubTitle>
            <div class="w-full mt-8">
              <div
                v-for="(item, index) in form.media.links"
                :key="index"
                class="flex flex-col mb-12 lg:mb-8"
              >
                <ReInput
                  :id="'media_l_' + index"
                  v-model="item.name"
                  :validation-errors="
                    validationErrors['media.links.' + index + '.name']
                  "
                  icon="/img/underline_icon.svg"
                  placeholder="Link elnevezése"
                  type="text"
                  class="w-full"
                />
                <ReTextarea
                  :id="'media_u_' + index"
                  v-model="item.url"
                  :rows="4"
                  :validation-errors="
                    validationErrors['media.links.' + index + '.url']
                  "
                  icon="/img/attachement_icon.svg"
                  placeholder="Link url, pl.: https://pelda.hu/link"
                  type="text"
                  class="w-full"
                />
                <div class="w-full flex flex-row justify-center">
                  <button
                    v-if="index == form.media.links.length - 1"
                    type="button"
                    class="inline action-icon icon-red-outline"
                    @click="form.media.links.push({ name: '', url: '' })"
                  >
                    <i class="fas fa-plus" />
                  </button>
                  <button
                    v-if="form.media.links.length > 0"
                    type="button"
                    :class="{ 'ml-2': index == form.media.links.length - 1}"
                    class="inline action-icon icon-red-outline"
                    @click="form.media.links.splice(index, 1)"
                  >
                    <i class="fas fa-minus" />
                  </button>
                </div>
              </div>
              <!-- <p
                v-if="form.media && form.media.links && form.media.links.length > 0"
                class="text-center"
              >
                Ha YouTube-linket adsz meg, az beágyazott videóként megjelenik a fotóalbum oldalán.
              </p> -->
            </div>

        
            <SubTitle
              title="Képek feltöltése"
              class="mt-3"
            />
            <div class="w-full mt-8">
              <ReUpload
                id="photos"
                v-model="files"
                :upload="{
                  url: '/upload'
                }"
                :size="4194304"
                :error="
                  validationErrors['photos']
                    ? validationErrors['photos'][0]
                    : ''
                "
                auto-upload
                has-clip
                has-preview
              />
              <div
                class="alert mt-10"
                role="alert"
              >
                A Folknaptár oldalain fix, 16:9 oldalarányú fekvő képek
                jelennek meg. A képek kiválasztása után vágóeszközünk
                segítségével egyszerűen megadhatod ezt a kivágatot.
              </div>
            </div>

        
            <SubTitle
              v-if="!form.group_event && form.time_details.length > 1"
              title="Egyedi adatok megadása a különböző dátumokhoz"
              class="mt-10 cursor-pointer"
              @click.capture="isShowMoreEvents = !isShowMoreEvents"
            >
              <template>
                <img
                  src="/img/icons/inputs/dropdown_arrow_icon.svg"
                  class="h-[16px] w-[16px] place-self-center mr-3 transform transition-all group-hover:text-gray-darkest duration-500 "
                  :class="{ 
                    'rotate-180': isShowMoreEvents
                  }"
                  @click.capture="isShowMoreEvents = !isShowMoreEvents"
                >
              </template>
            </SubTitle>
        
            <div
              v-if="isShowMoreEvents && !form.group_event && form.time_details.length > 1"
              class="w-full mt-8"
            >
              <div
                v-for="(event, index) in form.time_details"
                :key="index"
                class="w-full"
              >
                <hr v-if="index !== 0">
                <div class="w-full text-left mt-8 mb-4">
                  {{ event.from.date | filterDay }}
                </div>
                <div class="w-full flex flex-col lg:flex-row gap-3">
                  <div class="w-full lg:w-1/2 flex flex-col">
                    <ReInput
                      v-model="event.alt_title"
                      :validation-errors="
                        validationErrors['time_details.' + index + '.alt_title']
                      "
                      placeholder="Alkalom elnevezése"
                      type="text"
                      class="w-full"
                    />
                    <ReInput
                      v-model="event.note"
                      placeholder="Alkalomhoz fűződő megjegyzés"
                      type="text"
                      class="w-full"
                    />
                  <!-- far fa-user -->
                  </div>
                  <div class="w-full lg:w-1/2 flex flex-col">
                    <div class="flex flex-row gap-3">
                      <ReClock
                        v-model="event.from.time"
                        placeholder="Kezdés"
                        icon="/img/clock2_icon.svg"
                        class="w-1/2"
                        @change="event.from.fromGlobalTime = false"
                      />
                      <!-- <ReSelect
                        v-model="event.from.time"
                        :items="timesOfDay"
                        placeholder="Kezdés"
                        class="w-1/2"
                        icon="/img/clock2_icon.svg"
                        @change="event.from.fromGlobalTime = false"
                      /> -->
                      <ReClock
                        v-model="event.to.time"
                        placeholder="Kezdés"
                        icon="/img/clock2_icon.svg"
                        class="w-1/2"
                        @change="event.from.fromGlobalTime = false"
                      />
                      <!-- <ReSelect
                        v-model="event.to.time"
                        :items="timesOfDay"
                        placeholder="Vége"
                        class="w-1/2"
                        icon="/img/clock2_icon.svg"
                        @change="event.from.fromGlobalTime = false"
                      /> -->
                    </div>
                    <div class="flex flex-row gap-3">
                      <ReCheckbox
                        v-model="event.otherLocation"
                        type="left"
                        class="w-2/3 lg:w-1/2 text-left"
                      >
                        Eltérő helyszín használata
                      </ReCheckbox>
                      <div class="w-1/3 lg:w-1/2 text-right flex flex-row place-items-center place-content-center">
                        <span
                          class="hidden lg:inline text-red mr-2 ml-auto font-semibold"
                        >
                          Alkalom törlése
                        </span>
                        <a
                          type="button"
                          class="action-icon icon-fill icon-red mr-2 ml-0 cursor-pointer"
                          @click="removeEvent(index)"
                        >
                          <i class="fas fa-trash-alt" />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  v-if="event.otherLocation"
                  class="w-full"
                >
                  <div class="w-full flex flex-col lg:flex-row gap-3">
                    <div class="w-full lg:w-1/2">
                      <div class="search">
                        <GmapAutocomplete
                          @place_changed="setPlace($event, index)"
                        />
                      </div>
                      <GmapMap
                        v-if="form.location_details[event.related_location_detail]
                          .marker
                        "
                        :center="
                          form.location_details[event.related_location_detail]
                            .marker.position
                        "
                        :zoom="
                          form.location_details[event.related_location_detail]
                            .zoom
                        "
                        :options="{
                          zoomControl: true,
                          mapTypeControl: false,
                          scaleControl: false,
                          streetViewControl: false,
                          rotateControl: false,
                          fullscreenControl: true,
                          disableDefaultUi: false
                        }"
                        class="h-[210px] lg:h-[210px] w-full mb-4"
                        map-type-id="terrain"
                        @click="clickOnMap($event, index)"
                      >
                        <GmapMarker
                          v-if="
                            form.location_details[event.related_location_detail]
                              .marker
                          "
                          :position="
                            form.location_details[event.related_location_detail]
                              .marker.position
                          "
                          label="★"
                        />
                      </GmapMap>
                    </div>
                    <div class="w-full lg:w-1/2 flex-col">
                      <ReInput
                        id
                        v-model="
                          form.location_details[event.related_location_detail]
                            .place_name
                        "
                        class="w-full"
                        placeholder="Megnevezés (pl: Intézménynév)"
                        type="text"
                      />
                      <!-- fas fa-city-->
                      <div class="w-full flex flex-col lg:flex-row gap-3">
                        <ReInput
                          id
                          v-model="
                            form.location_details[event.related_location_detail]
                              .country
                          "
                          class="w-full lg:w-1/2"
                          placeholder="Ország"
                          type="text"
                          @blur="refreshMap(index)"
                        />
                        <ReInput
                          id
                          v-model="
                            form.location_details[event.related_location_detail]
                              .city
                          "
                          placeholder="Település"
                          type="text"
                          class="w-full lg:w-1/2"
                          @blur="refreshMap(index)"
                        />
                        <!-- fas fa-map-marker-alt -->
                      </div>
                      <div class="w-full flex flex-col lg:flex-row gap-3">
                        <ReInput
                          id
                          v-model="
                            form.location_details[event.related_location_detail]
                              .address
                          "
                          placeholder="Utca"
                          type="text"
                          class="w-full lg:w-1/2"
                          @blur="refreshMap(index)"
                        />
                        <!-- fas fa-map-signs -->
                        <div class="flex flex-row gap-3 w-full lg:w-1/2">
                          <ReInput
                            id
                            v-model="
                              form.location_details[event.related_location_detail]
                                .street_number
                            "
                            placeholder="Házszám"
                            type="text"
                            class="w-1/2"
                            @blur="refreshMap(index)"
                          />
                          <ReInput
                            id
                            v-model="
                              form.location_details[event.related_location_detail]
                                .zip
                            "
                            placeholder="Irányítószám"
                            class="w-1/2"
                            type="text"
                          />
                        </div>
                      
                      <!-- far fa-map -->
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="w-full flex place-items-center place-content-center mt-16">
              <button
                :disabled="isSaving"
                class="btn btn-red w-1/2 lg:w-1/6"
                type="button"
                @click.prevent="upload"
              >
                Mentés
              </button>
            </div>
          </div>

          <!-- <div
        id="facebookDialog"
        :class="{ show: facebookDialogVisible }"
        class="modal"
      >
        <div
          class="modal-dialog"
          role="document"
        >
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">
                Adatok importálása Facebook eseményből
              </h5>
              <button
                type="button"
                class="close"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <p>
                    Másold be ide az importálni kívánt facebook esemény linkjét!
                  </p>
                </div>
                <div class="col-12">
                  <ReInput
                    v-model="facebooklink"
                    icon="fab fa-facebook-f"
                    placeholder="Facebook esemény linkje"
                  />
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <div class="row">
                <div class="col-6">
                  <button
                    class="btn btn-primary"
                    type="default"
                    @click="loadFacebookEvent"
                  >
                    Importálás
                  </button>
                </div>
                <div class="col-6">
                  <button
                    class="btn btn-primary"
                    type="default"
                    @click="facebookDialogVisible = false"
                  >
                    Mégse
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> -->
        </section>
      </ReOverlayLoader>
    </PageHeader>
  </client-only>
</template>
<script>
import SubTitle from '~/components/folkradio/SubTitle.vue'
import ProfileHeader from "~/components/folkradio/ProfileHeader.vue";
import PageHeader from "~/components/folkradio/PageHeader.vue";
import ReOverlayLoader from "~/components/rxt/recomponent/ReOverlayLoader.vue";
import ReInput from "~/components/rxt/reform/ReInput.vue";
import ReClock from "~/components/rxt/reform/ReClock.vue";
import ReDraggable from "~/components/rxt/reform/ReDraggable.vue";
import ReSelect from "~/components/rxt/reform/ReSelect.vue";
import ReCheckbox from "~/components/rxt/reform/ReCheckbox.vue";
import ReUpload from "~/components/rxt/reform/ReUpload.vue";
import DatePicker from '~/components/rxt/reform/partials/DatePicker'

import ReTextarea from "~/components/rxt/reform/ReTextarea.vue";

export default {
  middleware: "auth",
  components: {
    // ReUpload,
    DatePicker,
    PageHeader,
    ProfileHeader,
    ReOverlayLoader,
    SubTitle,
    ReUpload,
    ReDraggable,
    ReInput,
    ReClock,
    ReSelect,
    ReCheckbox,
    ReTextarea
  },
  key(route) {
    return route.fullPath;
  },
  head() {
    return {
      titleTemplate: this.id
        ? "Esemény szerkesztése"
        : "Új esemény felvitele" + " | Folknaptár"
    };
  },
  validate({ params }) {
    if (!params.id) {
      return true;
    }
    return /^\d+$/.test(params.id);
  },
  filters: {
    filterDay(value) {
      // return value.getFullYear()+"-"+value.getMonth()+1+"-"+value.getDate();
      return new Date(value).toLocaleDateString("hu");
    }
  },
  data() {
    return {
      centerDialogVisible: false,
      facebookDialogVisible: false,
      clipperDialogVisible: false,
      facebooklink: "",
      id: null,
      clone: false,
      timesOfDay: [],

      // VIEW VALUES
      selectedDays: [],
      isShowMoreEvents: false,

      // IMG CLIPPER TEMP VARS
      imgTempData: null,
      imgPreview: null,
      imgTempIndex: 0,
      imgCanvas: 0,
      isImgUpload: false,

      // FORM UPLOAD
      form: {
        // NOT UPLOADED DATA
        group_event: true,
        manual_group_event: false,
        main_map_index: 0,
        main_img_index: 0,
        fromTime: null,
        toTime: null,
        note: "",

        // UPLOADABLE DATA
        types: [],
        title: "",
        url: "",
        description: "",
        org_name: "",
        org_email: "",
        org_phone: "",
        org_contact: "",
        location_details: [
          {
            // TODO if invalid location then error
            invalid_location: true,
            zoom: null,
            marker: {position:{lat: 47.14932639723332, lng: 20.34087591232901 }},
            city: "",
            zip: "",
            place_name: "",
            address: "",
            street_number: "",
            country: "Magyarország",
            lat: null,
            lng: null
          }
        ],
        time_details: [],
        media: {
          images: [],
          links: [{ name: "", url: "" }]
        }
      },
      isSaving: false,
      // VALIDATION MESSAGES
      validationErrors: {},
      showMap: true
    };
  },
  computed: {
    types() {
      return this.$store.state.eventTypes.map(item => {
        return {
          key: this.$unique(),
          value: item.id,
          text: item.type
        };
      });
    },
    groupeable() {
      for (let i = 0; i < this.selectedDays.length - 1; i++) {
        if (
          this.selectedDays[i + 1] &&
          (this.$moment(this.selectedDays[i], "YYYY-MM-DD")
            .add(1, "days")
            .date() !==
            this.$moment(this.selectedDays[i + 1], "YYYY-MM-DD").date() ||
            this.$moment(this.selectedDays[i], "YYYY-MM-DD").month() !==
              this.$moment(this.selectedDays[i + 1], "YYYY-MM-DD").month() ||
            this.$moment(this.selectedDays[i], "YYYY-MM-DD").year() !==
              this.$moment(this.selectedDays[i + 1], "YYYY-MM-DD").year())
        ) {
          return false;
        }
      }
      return true;
    },
    files: {
      get() {
        return this.form.media.images ? this.form.media.images : [];
      },
      set(val) {
        val.forEach((item, index) => {
          const result = this.form.media.images.findIndex(img => {
            return img.path === item.path || img.url === item.url;
          });
          if (result === -1) {
            this.form.media.images.push({
              file_name: result.file_name,
              path: result.path,
              url: result.url
            });
          }
        });
      }
    }
  },
  watch: {
    "form.group_event"(newGroupEvent, oldGroupEvent) {
      this.onGroupEvent(newGroupEvent)
      this.refreshTimeDetails(this.selectedDays);
    },
    selectedDays: {
      handler(newSelectedDays, oldSelectedDays) {
        let groupEvent = true;

        newSelectedDays.forEach((value, index) => {
          if (index === newSelectedDays.length - 1) {
            return;
          }
          const nowPlusOne = this.$moment(value).add(1, "days");
          const tomorrow = this.$moment(newSelectedDays[index + 1]);
          if (!nowPlusOne.isSame(tomorrow, "day")) {
            groupEvent = false;
          }
        });

        this.form.group_event = groupEvent;

        this.refreshTimeDetails(newSelectedDays);
      },
      deep: true
    },
    "form.fromTime"(newTime, oldTime) {
      this.form.time_details = this.form.time_details.map(value => {
        if (value.from.fromGlobalTime || this.form.time_details.length === 1) {
          value.from.time = newTime;
        }
        if (
          this.form.toTime &&
          (value.to.fromGlobalTime || this.form.time_details.length === 1)
        ) {
          value.to.time = this.form.toTime;
        }
        value.to.date = null;
        return value;
      });
    },
    "form.toTime"(newTime, oldTime) {
      this.form.time_details = this.form.time_details.map(value => {
        if (
          value.from.time &&
          (value.to.fromGlobalTime || this.form.time_details.length === 1)
        ) {
          value.to.time = newTime;
        }
        value.to.date = null;

        return value;
      });
    }
  },
  async asyncData(context) {
    let returnUrl = null;
    if (process.server) {
      returnUrl = "/fiokom/esemenyeim";
    } else {
      returnUrl = context.app.router.history.current.fullPath;
    }
    let clone = false;
    if (context.params.klon && context.params.klon === "klonozas") {
      clone = true;
    }

    if (context.params.id) {
      // try{
        let response = null
        let event = null
        try {

          response = await context.app.$axios.get(
            "v2/events/" + context.params.id
          );
          // eslint-disable-next-line
          event = response.data.data
        } catch(e) {
          console.log(e)
          context.error({
            statusCode: 404,
            message: "Szerver hiba, kérlek lépj kapcsolatba az üzemeltetőkkel!"
          });
        }

      // map back the types
      // console.log(event)
      // console.log(event.types)
      // event.types = 

      if (clone) {
        // eslint-disable-next-line
        let locationDetails = []
        // eslint-disable-next-line
        let timeDetails = []
        // event.time_details.forEach((td) => {
        //   if (context.app.$moment().isBefore(context.app.$moment(td.from.date))) {
        //     const locationDetail = event.location_details[td.related_location_detail]

        //     if (!locationDetails.find((ld) => { return ld.id === locationDetail.id })) {
        //       locationDetails.push(event.location_details[td.related_location_detail])
        //       td.related_location_detail = locationDetails.length - 1
        //     }

        //     timeDetails.push(td)
        //   }
        // })
        // if (!timeDetails.length || !locationDetails.length) {
        timeDetails.push(event.time_details[event.time_details.length - 1]);
        locationDetails.push(
          event.location_details[timeDetails[0].related_location_detail]
        );
        timeDetails[0].related_location_detail = 0;
        // }
        event.time_details = timeDetails;
        event.location_details = locationDetails;
      }

      event.time_details.forEach(value => {
        const locationDetail =
          event.location_details[value.related_location_detail];

        let streetNumber = locationDetail.street_number
          ? locationDetail.street_number
          : "";
        let address = locationDetail.address ? locationDetail.address : "";
        if (!locationDetail.splited) {
          locationDetail.splited = true;
          const addressSplit = locationDetail.address
            ? locationDetail.address.split(" ")
            : [];

          if (addressSplit.length > 1) {
            streetNumber = addressSplit[addressSplit.length - 1];
            addressSplit.pop(); // splice(addressSplit.length - 1, 1)
            address = addressSplit.join(" ");
          } else if (addressSplit.length === 1) {
            address = addressSplit[0];
          }
        }

        const lng = locationDetail.lng ? locationDetail.lng : 20.34087591232901;
        const lat = locationDetail.lat ? locationDetail.lat : 47.14932639723332;
        locationDetail.address = address;
        locationDetail.street_number = streetNumber;
        locationDetail.invalid_location = false;
        locationDetail.zoom = 7;
        locationDetail.marker = {
          position: { lat, lng }
        };

        value.otherLocation = value.related_location_detail !== 0;

        value.from.time = value.from.time ? value.from.time : null;
        value.to.time = value.to.time ? value.to.time : null;
      });

      // set the links
      if (!(event.media.links && event.media.links.length > 0)) {
        event.media.links = [{ url: "", name: "" }];
      }

      let mainImgIndex = 0;
      event.media.images.forEach((value, index) => {
        if (value.main) {
          mainImgIndex = index;
        }
      });
      event.description = event.description.replace(/<br>/g, "\n");
      let groupEvent = true;
      const selectedDays = [];
      const dayLength = 24 * 60 * 60 * 1000;

      if (event.time_details.length === 1 && event.time_details[0].to.date) {
        const fromDate = context.app.$moment(
          event.time_details[0].from.date,
          "YYYY-MM-DD"
        );
        const toDate = context.app.$moment(
          event.time_details[0].to.date,
          "YYYY-MM-DD"
        );
        const days = (toDate.valueOf() - fromDate.valueOf()) / dayLength + 1;

        for (let i = 0; i < days; i++) {
          selectedDays.push(
            context.app
              .$moment(event.time_details[0].from.date, "YYYY-MM-DD")
              .add(i, "days")
              .format("YYYY-MM-DD")
          );
        }

        groupEvent = true;
      } else {
        groupEvent = false;
        event.time_details.forEach(value => {
          selectedDays.push(
            context.app
              .$moment(value.from.date, "YYYY-MM-DD")
              .format("YYYY-MM-DD")
          );
        });
      }

      return {
        id: context.params.id,
        returnUrl,
        clone,
        form: {
          group_event: groupEvent,
          main_map_index: 0,
          main_img_index: mainImgIndex,
          fromTime: event.time_details[0].from.time,
          toTime: event.time_details[0].to.time,
          note: "",

          types: event.types.filter(item => { return item }).map(value => {
            return value.id;
          }),
          title: event.title,
          url: event.url,
          description: event.description,
          org_name: event.org_name,
          org_email: event.org_email,
          org_phone: event.org_phone,
          org_contact: event.org_contact,
          location_details: event.location_details,
          time_details: event.time_details,
          media: event.media
        },
        selectedDays
      };
    } else {
      return {
        id: null,
        returnUrl,
        clone,

        // VIEW VALUES
        selectedDays: [],
        isShowMoreEvents: false,

        // IMG CLIPPER TEMP VARS
        imgTempData: null,
        imgPreview: null,
        imgTempIndex: 0,
        imgCanvas: 0,
        isImgUpload: false,

        // FORM UPLOAD
        form: {
          // NOT UPLOADED DATA
          group_event: true,
          manual_group_event: false,
          main_map_index: 0,
          main_img_index: 0,
          fromTime: null,
          toTime: null,
          note: "",

          // UPLOADABLE DATA
          types: [],
          title: "",
          url: "",
          description: "",
          org_name: "",
          org_email: "",
          org_phone: "",
          org_contact: "",
          location_details: [
            {
              // TODO if invalid location then error
              invalid_location: true,
              zoom: null,
            marker: {position:{lat: 47.14932639723332, lng: 20.34087591232901 }},
              city: "",
              zip: "",
              place_name: "",
              address: "",
              street_number: "",
              country: "Magyarország",
              lat: null,
              lng: null
            }
          ],
          time_details: [],
          media: {
            images: [],
            links: [{ name: "", url: "" }]
          }
        },

        // VALIDATION MESSAGES
        validationErrors: {}
      };
    }
  },
  async fetch() {
    await Promise.all([
      this.$store.dispatch("loadEventTypes")
    ])
  },
  beforeMount(){
    for(let h=0; h < 24; h++){
      for(let m=0; m < 60; m+=15){
        let time = this.$moment(h+':'+m+':00', 'H:m:ss').format("HH:mm")
        this.timesOfDay.push({
          value: this.$moment(h+':'+m+':00', 'H:m:ss').format("HH:mm:ss"),
          key: this.$moment(h+':'+m+':00', 'H:m:ss').format("HH:mm:ss"),
          text: time
        })
      }
    }
  },
  created(){
    this.$forceUpdate()
  },
  methods: {
    changeSelectedDayAtIndex(event, index) {
      this.selectedDays.splice(index, 1, event);

      this.selectedDays.sort((a, b) => {
        if (new Date(a).valueOf() <= new Date(b).valueOf()) {
          return -1;
        } else {
          return 1;
        }
      });

      // this.refreshTimeDetails(this.selectedDays)
    },
    refreshTimeDetails(times) {
      const fromTime = this.form.fromTime;
      let toTime = this.form.toTime;
      // let add_day_to_from = 1;
      // let add_day_to_to = 1;
      if (!fromTime) {
        toTime = null;
      }

      if (this.form.group_event) {
        this.form.time_details = [];
        this.form.time_details.push({
          from: {
            fromGlobalTime: true,
            date: times[0],
            time: fromTime,
            tz: ""
          },
          to: {
            fromGlobalTime: true,
            date: times[times.length - 1],
            time: toTime,
            tz: ""
          },
          alt_title: "",
          note: "",
          otherLocation: false,
          related_location_detail: 0
        });
      } else {
        times.forEach((value, index) => {
          const i = this.form.time_details.findIndex(element => {
            return element.from.date === value;
          });
          if (i === -1) {
            this.form.time_details.push({
              from: {
                fromGlobalTime: true,
                date: value,
                time: fromTime,
                tz: ""
              },
              to: {
                fromGlobalTime: true,
                date: value,
                time: toTime,
                tz: ""
              },
              alt_title: "",
              note: "",
              otherLocation: false,
              related_location_detail: 0
            });
          } else {
            this.form.time_details[i].to.date = value;
            this.form.time_details[i].to.time = toTime;
            this.form.time_details[i].to.tz = "";
          }
        });

        this.form.time_details.forEach((element, index) => {
          if (
            !times.find(value => {
              return element.from.date === value;
            })
          ) {
            this.form.time_details.splice(index, 1);
          }
        });

        this.form.time_details.sort((a, b) => {
          if (
            new Date(a.from.date).valueOf() <= new Date(b.from.date).valueOf()
          ) {
            return -1;
          } else {
            return 1;
          }
        });
      }
    },
    changeFocus() {
      document.getElementById("textareaid").focus();
    },
    updateHTML(e) {
      // this.$emit('input', e.target.innerHTML);
      this.form.description = e.target.innerHTML;
    },
    loadFacebookEvent() {
      this.form.title = "Berka - Vizeli Bálint és bandája a Fonóban";
      this.form.description =
        "Táncház egyszerre két helyszínen tánctanítással \n\nImmár tizedik éve tartja rendszeres táncházát a Fonóban minden második pénteken a Berka együttes, és ebben segítségükre vannak a Liszt Ferenc Zeneművészeti Egyetem legkiválóbb diákjai, muzsikusai. Két teremben párhuzamosan zajlik a táncház: a nagyteremben moldvai, az előtérben vonós táncházat tartunk.\nVárunk Téged is sok szeretettel, akár táncolni szeretnél, akár csak a muzsikát akarod élvezni!\n\nMuzsikálnak: \n Berka - moldvai táncház \n Táncmester: Gyurka Fábián\n Vizeli Bálint és bandája - vonós táncház\n\nJegyár: 1000 Ft";
      this.form.location_details[0].city = "Budapest";
      this.form.location_details[0].place_name = "Fonó Budai Zeneház";
      this.form.location_details[0].zip = "1116";
      this.form.location_details[0].address = "Sztregova u.";
      this.form.location_details[0].street_number = "3.";
      this.form.org_email = "fono@fono.hu";
      this.form.org_phone = "(1) 206 5300";
      this.form.org_name = "Fonó Budai Zeneház";
      this.form.fromTime = "20:30:00";
      this.form.toTime = "01:00:00";
      this.form.url = "https://www.facebook.com/events/2345197712426157/";
      this.form.media.links[0] = {
        name: "Facebookos",
        url: "https://www.facebook.com/events/2345197712426157/"
      };
      this.selectedDays = ["2019-05-10"];

      this.refreshMap(-1);
      /* let url = this.facebooklink;

      let urlSplit = url.split("/");
      let id = url[urlSplit.length - 2];

      //this.$axios.get('https://graph.facebook.com') */
    },
    upload() {
      // TODO time id
      this.isSaving = true;
      const length = this.form.time_details.length;

      for (let i = 0; i < length; i++) {
        const currDay = this.form.time_details[i];
        const location = this.form.location_details[
          currDay.related_location_detail
        ];

        if (
          !location.added_street_number &&
          location.street_number.length > 0
        ) {
          if (
            location.street_number[location.street_number.length - 1] !== "."
          ) {
            location.street_number += ".";
          }
          location.address = location.address + " " + location.street_number;
          location.added_street_number = true;
        }
        if (location.marker && location.marker.position) {
          location.lat = location.marker.position.lat
            ? location.marker.position.lat
            : null;
          location.lng = location.marker.position.lng
            ? location.marker.position.lng
            : null;
        } else {
          location.lat = null;
          location.lng = null;
        }

        if (currDay.to.time) {
          const time = this.$moment(currDay.to.time, "HH:mm:ss");

          if (time && time.hour() === 24) {
            time.hour(0);
          }

          currDay.to.time = time.format("HH:mm:ss");
        }

        currDay.from.tz = "+01:00"; // TODO get from country
        currDay.to.tz = "+01:00"; // TODO
      }

      if (
        this.form.media.links &&
        this.form.media.links[0].name === "" &&
        this.form.media.links[0].url === "" &&
        this.form.media.links.length === 1
      ) {
        this.form.media.links = [];
      }

      if (this.form.media.images[this.form.main_img_index] === void 0) {
        this.form.main_img_index = 0;
      }
      this.form.media.images.forEach((value, index) => {
        if (index === this.form.main_img_index) {
          value.main = true;
        } else {
          value.main = false;
        }
      });

      let uri = "/v2/events";
      if (this.id && !this.clone) {
        this.form._method = "PUT";
        uri += "/" + this.id;
      } else if (this.clone) {
        delete this.form.id;
      }
      this.form.description = this.form.description.replace(/\n/g, "<br>");
      // console.log(this.form)
      const formData = new FormData();

      this.buildFormData(formData, this.form);

      // RESTORE PREVIOUSLY MODIFIED DATA
      if (this.form.media.links.length === 0) {
        this.form.media.links.push({ name: "", url: "" });
      }
      this.form.location_details.forEach(value => {
        const addressSplit = value.address ? value.address.split(" ") : [];
        let streetNumber = "";
        let address = "";

        if (addressSplit.length > 1) {
          streetNumber = addressSplit[addressSplit.length - 1];
          addressSplit.splice(addressSplit.length - 1, 1);
          address = addressSplit.join(" ");
        } else if (addressSplit.length === 1) {
          address = addressSplit[0];
        }

        value.address = address;
        value.street_number = streetNumber;
        value.added_street_number = false;
      });
      for (let i = 0; i < length; i++) {
        const currDay = this.form.time_details[i];
        currDay.from.time = currDay.from.time ? currDay.from.time : null;
        currDay.to.time = currDay.to.time ? currDay.to.time : null;
      }

      // SEND DATA
      this.$axios
        .post(uri, formData)
        .then(response => {
          this.$rxt.toast("Sikeres feltöltés!", {
            title: "Sikeres művelet",
            autoHideDelay: 3500,
            variant: "success"
          });
          this.$router.push(this.returnUrl);
          this.isSaving = false;
        })
        .catch(error => {
          this.isSaving = false;
          if (error.response && error.response.status === 422) {
            // console.log(error.resonse.data);
            this.validationErrors = error.response.data.details;
            this.validationErrors["media.images"] = [];

          Object.keys(this.validationErrors).forEach(key => {
              if (key.search("media.images") !== -1) {
                this.validationErrors["media.images"].push(
                  this.validationErrors[key][0]
                );
              }
            });
            this.$rxt.toast(
              "Javítsd az űrlapon a piros magyarázószöveggel megjelölt hibát!",
              {
                title: "Sikertelen művelet",
                autoHideDelay: 3500,
                variant: "danger"
              }
            );

            // TODO more status codes
          } else if (error.response.status === 401) {
            this.$rxt.toast(
              "Önnek nincs jogosultsága módosítani ezt az eseményt!",
              {
                title: "Sikertelen művelet",
                autoHideDelay: 3500,
                variant: "danger"
              }
            );

            this.$router.push("/esemenyeim");
          } else if (error.response.status === 403) {
            this.$rxt.toast("Kérjük a feltöltséhez jelentkezzen be!", {
              title: "Sikertelen művelet",
              autoHideDelay: 3500,
              variant: "danger"
            });

            this.$router.push("/belepes");
          } else {
            this.$rxt.toast(
              "Szerver hiba, kérjük keresse fel az oldal üzemeltetőit!",
              {
                title: "Sikertelen művelet",
                autoHideDelay: 3500,
                variant: "danger"
              }
            );
          }
        });
    },
    compareDetails(day1, day2) {
      if (
        day1.related_location_detail === day2.related_location_detail &&
        day1.alt_title === day2.alt_title &&
        day1.note === day2.note &&
        day1.from.time === day2.from.time
      ) {
        return true;
      }
      return false;
    },
    findOrAddLocation(searchable, location) {
      const index = searchable.findIndex((value, index) => {
        return JSON.stringify(value) === JSON.stringify(location);
      });
      if (index === -1) {
        searchable.push(location);
        return searchable.length - 1;
      }
      return index;
    },
    removeEvent(numb) {
      const locationDetailIndex = this.form.time_details[numb]
        .related_location_detail;
      const anotherOneWithSameMapIndex = this.form.time_details.findIndex(
        (value, index) => {
          return (
            value.related_location_detail === locationDetailIndex &&
            index !== numb
          );
        }
      );

      if (anotherOneWithSameMapIndex === -1) {
        this.form.time_details = this.form.time_details.map((value, index) => {
          if (value.related_location_detail > locationDetailIndex) {
            value.related_location_detail = value.related_location_detail - 1;
          }
          return value;
        });
        this.form.location_details.splice(locationDetailIndex, 1);
      }

      this.$refs.rxtCalendar.handleClose(
        this.form.time_details[numb].from.date
      );
      this.form.time_details.splice(numb, 1);

      this.form.time_details = this.form.time_details.map((value, index) => {
        if (anotherOneWithSameMapIndex === -1) {
          if (index === 0) {
            value.otherLocation = true;
            this.form.main_map_index = value.related_location_detail;
          }
        } else if (anotherOneWithSameMapIndex !== 0) {
          if (value.related_location_detail === locationDetailIndex) {
            value.otherLocation = true;
          } else if (
            value.related_location_detail !== locationDetailIndex &&
            index === 0
          ) {
            value.otherLocation = true;
            this.form.main_map_index = value.related_location_detail;
          }
        }
        return value;
      });
    },
    refreshMap(numb) {
      let index = 0;
      let location = null;

      // if it exists but it has a unique location
      if (!this.form.time_details[numb]) {
        index = this.form.main_map_index;
        location = this.form.location_details[this.form.main_map_index];
      } else {
        index = this.form.time_details[numb].related_location_detail;
        location = this.form.location_details[index];
      }

      const geocoder = new window.google.maps.Geocoder();

      geocoder.geocode(
        {
          address:
            location.city +
            "," +
            location.address +
            " " +
            location.street_number +
            " , " +
            location.country
        },
        (results, status) => {
          if (
            status === window.google.maps.GeocoderStatus.OK &&
            results.length
          ) {
            location.zoom = 11;
            location.marker = {};
            location.marker.position = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            };

            location.invalid_location = false;
          } else {
            location.invalid_location = true;
            this.$rxt.toast("Nem található ilyen helyszín!", {
              title: "Sikertelen művelet",
              autoHideDelay: 3500,
              variant: "danger"
            });
          }

          this.form.location_details.splice(index, 1, location);
        }
      );
    },
    clickOnMap(event, numb) {
      let index = 0;
      let location = null;

      // if the date does not exist
      if (!this.form.time_details[numb]) {
        index = this.form.main_map_index;
        location = this.form.location_details[this.form.main_map_index];
      } else if (
        this.form.time_details[numb] &&
        this.form.time_details[numb].related_location_detail ===
          this.form.main_map_index
      ) {
        /// if the date exists but it has the main location
        const obj = {};
        this.form.location_details.push(obj);
        index = this.form.location_details.length - 1;
        this.form.time_details[numb].related_location_detail = index;
        location = this.form.location_details[index];
      } else {
        // if it exists but it has a unique location
        index = this.form.time_details[numb].related_location_detail;
        location = Object.assign({}, this.form.location_details[index]);
      }

      location.invalid_location = false;
      location.marker = {};
      location.marker.position = {
        lat: event.latLng.lat(),
        lng: event.latLng.lng()
      };
      const geocoder = new window.google.maps.Geocoder();
      geocoder.geocode(
        { latLng: location.marker.position },
        (results, status) => {
          if (
            status === window.google.maps.GeocoderStatus.OK &&
            results.length
          ) {
            results = results[0].address_components;

            location.address = "";
            location.city = "";
            location.country = "";
            location.zip = "";
            location.street_number = "";
            for (let i = 0; i < results.length; i++) {
              const j = results[i].types.findIndex((value, index) => {
                if (
                  [
                    "locality",
                    "administrative_area_level_3",
                    "sublocality"
                  ].findIndex(val => {
                    return val === value;
                  }) !== -1
                ) {
                  return true;
                }
                return false;
              });

              if (
                results[i].types[0] === "route" ||
                results[i].types.length === 0
              ) {
                location.address = results[i].long_name;
              } else if (j !== -1) {
                location.city = results[i].long_name;
              } else if (results[i].types[0] === "country") {
                location.country = results[i].long_name;
              } else if (results[i].types[0] === "postal_code") {
                location.zip = results[i].long_name;
              } else if (results[i].types[0] === "street_number") {
                location.street_number = results[i].long_name;
              }
            }

            location.zoom = 16;

            this.form.location_details.splice(index, 1, location);
          }
        }
      );
    },
    setPlace(event, numb) {
      let index = 0;
      let location = null;

      // if the date does not exist
      if (!this.form.time_details[numb]) {
        index = this.form.main_map_index;
        location = this.form.location_details[this.form.main_map_index];
      } else if (
        this.form.time_details[numb] &&
        this.form.time_details[numb].related_location_detail ===
          this.form.main_map_index
      ) {
        /// if the date exists but it has the main location
        this.form.location_details.push({});
        index = this.form.location_details.length - 1;
        this.form.time_details[numb].related_location_detail = index;
        location = this.form.location_details[index];
      } else {
        // if it exists but it has a unique location
        index = this.form.time_details[numb].related_location_detail;
        location = this.form.location_details[index];
      }

      // if the $event is empty, then return with the default data
      if (event.name.length === 0) {
        location.center = { lat: 47.14932639723332, lng: 20.34087591232901 };
        location.zoom = 16;
        location.address = "";
        location.city = "";
        location.country = "";
        location.zip = "";
        location.street_number = "";

        this.form.location_details.splice(index, 1, location);
        return;
      }

      if (event.address_components) {
        location.center = {
          lat: event.geometry.location.lat(),
          lng: event.geometry.location.lng()
        };

        location.marker = {};
        location.marker.position = {
          lat: event.geometry.location.lat(),
          lng: event.geometry.location.lng()
        };

        location.zoom = 11;
        location.address = "";
        location.city = "";
        location.country = "";
        location.zip = "";
        location.street_number = "";

        for (let i = 0; i < event.address_components.length; i++) {
          const j = event.address_components[i].types.findIndex(
            (value, index) => {
              if (
                [
                  "locality",
                  "administrative_area_level_3",
                  "sublocality"
                ].findIndex(val => {
                  return val === value;
                }) !== -1
              ) {
                return true;
              }
              return false;
            }
          );

          if (
            event.address_components[i].types[0] === "route" ||
            event.address_components[i].types.length === 0
          ) {
            location.address = event.address_components[i].long_name;
          } else if (j !== -1) {
            location.city = event.address_components[i].long_name;
          } else if (event.address_components[i].types[0] === "country") {
            location.country = event.address_components[i].long_name;
          } else if (event.address_components[i].types[0] === "postal_code") {
            location.zip = event.address_components[i].long_name;
          } else if (event.address_components[i].types[0] === "street_number") {
            location.street_number = event.address_components[i].long_name;
          }
        }

        this.form.location_details.splice(index, 1, location);
      } else {
        const geocoder = new window.google.maps.Geocoder();
        geocoder.geocode({ address: event.name }, (results, status) => {
          if (
            status === window.google.maps.GeocoderStatus.OK &&
            results.length
          ) {
            location.center.lat = results[0].geometry.location.lat();
            location.center.lng = results[0].geometry.location.lng();
            location.zoom = 16;
            location.marker = {};
            location.marker.position = {
              lat: results[0].geometry.location.lat(),
              lng: results[0].geometry.location.lng()
            };

            location.invalid_location = false;
          } else {
            location.invalid_location = true;
            this.$rxt.toast("Nem található ilyen helyszín!", {
              title: "Sikertelen művelet",
              autoHideDelay: 3500,
              variant: "danger"
            });
          }

          this.form.location_details.splice(index, 1, location);
        });
      }
    },
    onGroupEvent(event) {
      if (this.form.group_event) {
        this.form.manual_group_event = false;
      } else {
        this.form.manual_group_event = true;
      }
    },
    fetch(url, saveCallback) {
      fetch(url)
        .then(function(response) {
          if (response.ok) {
            return response.blob();
          }
          throw new Error("Network response was not ok.");
        })
        .then(saveCallback);
      // .catch((error) => {
      //   console.log(error)
      // })
    }
  }
};
</script>
